import React from 'react';
import { shape, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import Flex from '../../../atoms/Flex';
import Text from '../../../atoms/Text';
import { MINIATURE } from '../../../constants';

const ProductCardGeoLocTags = ({
  geoLocTags,
  displayMode
}) => {
  return geoLocTags != null && geoLocTags.title ? /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: displayMode === MINIATURE ? 'center' : null,
    gap: 1
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    name: geoLocTags.icon || 'FastDelivery',
    color: "text.primary",
    width: 30,
    height: 30
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    color: "text.primary",
    fontSize: [1, 1, 2, 2],
    fontWeight: "medium"
  }, geoLocTags.title))) : null;
};

process.env.NODE_ENV !== "production" ? ProductCardGeoLocTags.propTypes = {
  geoLocTags: shape({
    title: string,
    icon: string
  }),
  displayMode: string
} : void 0;
export default ProductCardGeoLocTags;